import React from "react";
import StoryImageSlider from "components/stories/StoryImageSlider";
import { useProfile } from "app/context";
import { usePostStoryContext } from "components/stories/post-stories-v2/contexts/PostStoryContext";
import useAddTags from "components/stories/post-stories-v2/hooks/useAddTags";
import StoryVideo from "components/stories/post-stories-v2/common/PostStoryForm/StoryVideo";
import { isMediaVideoType } from "components/stories/post-stories-v2/utils";

const PostStoryMediaAI: React.FC<{}> = () => {
  const { profile } = useProfile();
  const {
    state: {
      currentBody: postStoryCurrentBody,
      currentStory,
      selectedPrompt,
      selectedImages,
      selectedMedia
    },
    selectedOptionsRef,
    cleanedMediaData,
    getSelectedMediaUrl,
    handleOpenCropImage,
    handleMediaEdited,
    handleRemoveImage
  } = usePostStoryContext();
  const addTags = useAddTags({ tags: selectedOptionsRef.current });
  const currentBody = postStoryCurrentBody ? addTags(postStoryCurrentBody) : "";

  return (
    <div className="StoryMedia-Background-current">
      {isMediaVideoType(selectedMedia as Blob) ? (
        <StoryVideo currentBody={currentBody} />
      ) : (
        <StoryImageSlider
          currentBody={currentBody}
          currentStory={currentStory}
          getSelectedMediaUrl={getSelectedMediaUrl}
          images={selectedImages}
          mediaData={cleanedMediaData}
          onOpenCropImage={handleOpenCropImage}
          onMediaEdited={handleMediaEdited}
          onRemoveImage={handleRemoveImage}
          profile={profile}
          selectedPrompt={selectedPrompt}
        />
      )}
    </div>
  );
};

export default PostStoryMediaAI;
